import { styled, Typography } from '@material-ui/core';

import { down } from '../../../../assets/style/breakpointHelpers';
import { domTag } from '../../../utils/styledFilter';

export const HeaderContainer = styled('div')({
	display: 'flex',
	alignItems: 'center',
	marginBottom: 20,
});

export const AccordionSection = styled('div')({
	width: '100%',
	borderRadius: 'var(--radius-lg)',
	border: '1px solid var(--color-border-default)',
	boxSizing: 'border-box',
	backgroundColor: 'var(--color-bg-elevated)',
	transition: 'background-color var(--transition-normal), border-color var(--transition-normal)',
});

export const AccordionRow = styled(domTag('div', ['noborder']))(({ noborder }: { noborder?: 'true' | 'false' }) => ({
	width: '100%',
	borderBottom: noborder === 'true' ? 'none' : '1px solid var(--color-border-subtle)',
	boxSizing: 'border-box',
	padding: '3px 20px',
	display: 'flex',
	flexDirection: 'column',
}));

export const AccordionRowHeader = styled('div')({
	'width': '100%',
	'boxSizing': 'border-box',
	'height': 'auto',
	'padding': '10px 0',
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'space-between',
	'cursor': 'pointer',
	'borderRadius': 'var(--radius-md)',
	'transition': 'background-color var(--transition-fast)',
	'&:hover': {
		backgroundColor: 'var(--color-bg-hover)',
	},
	'&:focus-visible': {
		outline: '2px solid var(--color-border-focus)',
		outlineOffset: 2,
	},
});

export const AccordionRowBody = styled('div')({
	width: '100%',
	boxSizing: 'border-box',
	height: 'auto',
	padding: '10px 50px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	animation: 'fadeIn 0.2s ease-out',
});

export const AccordionBodyHtml = styled('div')({
	'width': '100%',
	'boxSizing': 'border-box',
	'height': 'auto',
	'display': 'flex',
	'flexDirection': 'column',
	'alignItems': 'flex-start',
	'color': 'var(--color-text-secondary)',
	'fontFamily': 'var(--font-family-regular)',
	'& p': {
		fontSize: 'var(--text-body-sm-size)',
		lineHeight: 'var(--leading-relaxed)',
	},
	'& li': {
		fontSize: 'var(--text-body-sm-size)',
		lineHeight: 'var(--leading-relaxed)',
		marginBottom: 10,
	},
	'& a': {
		color: 'var(--color-text-link)',
		textDecoration: 'underline',
		transition: 'color var(--transition-fast)',
	},
	'& a:hover': {
		color: 'var(--color-text-link-hover)',
	},
	[down('md')]: {
		'& p': {
			fontSize: 'var(--type-xs)',
			lineHeight: 'var(--leading-normal)',
		},
		'& li': {
			fontSize: 'var(--type-xs)',
			lineHeight: 'var(--leading-normal)',
		},
	},
});

export const AccordionHeaderTextNumber = styled(Typography)({
	fontFamily: 'var(--font-family-semibold)',
	textTransform: 'capitalize',
	fontSize: 'var(--text-body-sm-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	color: 'var(--color-brand-primary)',
	width: 30,
	[down('md')]: {
		fontSize: 'var(--type-xs)',
	},
});

export const AccordionHeaderText = styled(Typography)({
	fontFamily: 'var(--font-family-medium)',
	textTransform: 'capitalize',
	fontSize: 'var(--text-body-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	color: 'var(--color-text-primary)',
	[down('md')]: {
		fontSize: 'var(--type-xs)',
	},
});

export const AccordionHeaderTextLeft = styled('div')({
	display: 'flex',
	alignItems: 'center',
});

export const AccordionBodyText = styled(Typography)({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-body-sm-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	color: 'var(--color-text-secondary)',
	[down('md')]: {
		fontSize: 'var(--type-xs)',
	},
});

export const AccordionHeaderIcon = styled('i')({
	'fontSize': 'var(--type-xs)',
	'margin': 0,
	'color': 'var(--color-brand-primary)',
	'padding': 8,
	'borderRadius': 'var(--radius-md)',
	'transition': 'background-color var(--transition-fast), color var(--transition-fast)',
	'&:hover': {
		backgroundColor: 'var(--color-bg-hover)',
	},
});

export const HeaderText = styled(Typography)({
	fontFamily: 'var(--font-family-medium)',
	textTransform: 'capitalize',
	fontSize: 'var(--text-body-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	marginRight: 5,
	color: 'var(--color-text-primary)',
});

export const HeaderBodyText = styled(Typography)({
	fontFamily: 'var(--font-family-semibold)',
	textTransform: 'capitalize',
	fontSize: 'var(--text-h3-size)',
	lineHeight: 'var(--leading-tight)',
	margin: 0,
	marginRight: 25,
	color: 'var(--color-text-primary)',
});
